import { api } from './api';
import { unauthorizedError } from './state';

export const listDeals = () => (dispatch) => {
  return api
    .get(`/admin/deals`)
    .then((response) => {
      dispatch({ type: 'LIST_DEALS', data: response.data });
    })
    .catch(function (error) {
      console.log('ERROR', error);
      alert(error);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};

export const createDeal = (item) => (dispatch) => {
  return api
    .post(`/admin/deals`, item)
    .then((response) => {
      alert('Created');
      dispatch(listDeals());
    })
    .catch(function (error) {
      alert('Create ERROR');
      console.log(error);
      console.log(error.response.data);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};

export const updateDeal = (item) => (dispatch) => {
  return api
    .put(`/admin/deals/${item.id}`, item)
    .then((response) => {
      alert('Updated');
      dispatch(listDeals());
    })
    .catch(function (error) {
      alert('Update ERROR');
      console.log(error);
      console.log(error.response.data);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};

export const removeDeal = (id) => (dispatch) => {
  return api
    .delete(`/admin/deals/${id}`)
    .then((response) => {
      alert('Deleted');
      dispatch(listDeals());
    })
    .catch(function (error) {
      alert('Delete ERROR');
      console.log(error);
      console.log(error.response.data);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};
